/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Equipment_HelperInputs */

const en_us2_profile_editors_equipment_helper = /** @type {(inputs: Profile_Editors_Equipment_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tick everything you have at hand. Only what you can do goes into the plan.`)
};

const pt_br2_profile_editors_equipment_helper = /** @type {(inputs: Profile_Editors_Equipment_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marque tudo o que você tem à mão. Só entra no plano o que dá para fazer.`)
};

const es_419_profile_editors_equipment_helper = /** @type {(inputs: Profile_Editors_Equipment_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca todo lo que tienes a mano. Solo entra al plan lo que puedes hacer.`)
};

const pt_pt2_profile_editors_equipment_helper = /** @type {(inputs: Profile_Editors_Equipment_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca tudo o que tens à mão. Só entra no plano o que consegues fazer.`)
};

const fr_fr2_profile_editors_equipment_helper = /** @type {(inputs: Profile_Editors_Equipment_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coche tout ce que tu as sous la main. Seul ce que tu peux faire entre dans le programme.`)
};

const de_de2_profile_editors_equipment_helper = /** @type {(inputs: Profile_Editors_Equipment_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähl alles aus, was du zur Hand hast. Nur was du machen kannst, kommt in den Plan.`)
};

const it_it2_profile_editors_equipment_helper = /** @type {(inputs: Profile_Editors_Equipment_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona tutto quello che hai a disposizione. Nella scheda entra solo quello che puoi fare.`)
};

/**
* | output |
* | --- |
* | "Tick everything you have at hand. Only what you can do goes into the plan." |
*
* @param {Profile_Editors_Equipment_HelperInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_equipment_helper = /** @type {((inputs?: Profile_Editors_Equipment_HelperInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Equipment_HelperInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_equipment_helper(inputs)
	if (locale === "es-419") return es_419_profile_editors_equipment_helper(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_equipment_helper(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_equipment_helper(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_equipment_helper(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_equipment_helper(inputs)
	return en_us2_profile_editors_equipment_helper(inputs)
});
export { profile_editors_equipment_helper as "profile-editors.equipment_helper" }